import React, {useState} from 'react';
import {Alert, Box, Chip, IconButton, Paper, Snackbar, Stack, TextField, Tooltip, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {Delete} from "@mui/icons-material";

const MailPill = ({
                      pill,
                      expanded,
                      toggleExpanded,
                      responses,
                      handleResponseChange,
                      toggleDoneStatus,
                      deleteTicket
                  }) => {
    const [snackbar, setSnackbar] = useState({open: false, message: '', severity: ''});

    const handleSnackbarClose = () => {
        setSnackbar({...snackbar, open: false});
    };

    const handleDelete = async () => {
        try {
            await deleteTicket(pill.id);
            setSnackbar({
                open: true,
                message: 'Ticket deleted successfully.',
                severity: 'success',
            });
        } catch (error) {
            setSnackbar({
                open: true,
                message: 'Failed to delete ticket. Please try again.',
                severity: 'error',
            });
        }
    };

    const handleToggleDone = () => {
        let message = '';
        let severity = '';

        if (pill.done) {
            message = 'Status changed to Open.';
            severity = 'warning';
        } else {
            message = 'Status changed to Done.';
            severity = 'success';
        }

        toggleDoneStatus(pill.id);
        setSnackbar({open: true, message, severity});
    };

    return (
        <Paper
            key={pill.id}
            sx={{
                mb: 5,
                p: 2,
                boxShadow: expanded ? '0 4px 8px rgba(0,0,0,0.2)' : 'none',
            }}
        >
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{flexWrap: 'wrap', justifyContent: 'space-between'}}
            >
                <Chip
                    label={
                        <Box
                            sx={{
                                whiteSpace: 'normal',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {new Date(pill.date).toLocaleString('de-DE', {
                                timeZone: 'UTC',
                                day: '2-digit',
                                month: '2-digit',
                                year: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                            })}
                        </Box>
                    }
                    sx={{width: 120, height: 50, fontSize: 'small'}}
                />

                <Chip
                    label={
                        <Box
                            sx={{
                                whiteSpace: 'normal',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {pill.summary}
                        </Box>
                    }
                    sx={{
                        width: 500,
                        height: 50,
                        fontSize: 'small',
                        fontWeight: 'bold',
                    }}
                />

                <Chip label={
                    <Box
                        sx={{
                            whiteSpace: 'normal',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {pill.intent}
                    </Box>
                } sx={{width: 140, height: 50, fontSize: 'small'}}/>
                <Chip label={
                    <Box
                        sx={{
                            whiteSpace: 'normal',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {pill.sentiment}
                    </Box>
                } sx={{width: 140, height: 50, fontSize: 'small'}}/>
                <Chip label={
                    <Box
                        sx={{
                            whiteSpace: 'normal',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        }}
                    >
                        {pill.name}
                    </Box>
                } sx={{width: 140, height: 50, fontSize: 'small'}}/>
                <Chip
                    label={pill.done ? 'Done' : 'Open'}
                    color={pill.done ? 'success' : 'default'}
                    sx={{width: 110, fontSize: 'small'}}
                />

                <IconButton onClick={() => toggleExpanded(pill.id)} sx={{width: 40}}>
                    {expanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                </IconButton>
            </Stack>

            {expanded && (
                <Box sx={{borderRadius: '4px', alignItems: 'center'}}>
                    <Box sx={{mt: 1, mb: 0, display: 'flex'}}>
                        <Box sx={{width: '100%'}}>
                            <Typography fontWeight={"bold"} variant="subtitle2">Original Email:</Typography>
                            <Typography variant="body2" sx={{mb: 2}}>
                                <TextField
                                    slotProps={{
                                        input: {
                                            readOnly: true,
                                        },
                                    }}
                                    variant="filled"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    value={pill.originalEmail}
                                    sx={{mb: 2, color: 'inherit'}}
                                    color="primary"
                                />
                            </Typography>
                        </Box>
                        <Box sx={{width: 50}}></Box>
                        <Box sx={{width: '100%'}}>
                            <Typography fontWeight={"bold"} variant="subtitle2">Attributes:</Typography>

                            <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ rowGap: 2}}>
                                <Chip label={`Address: ${pill.address}`} sx={{ fontSize: 'small' }} />
                                <Chip label={`Meter Number: ${pill.meter_number}`} sx={{ fontSize: 'small' }} />
                                <Chip label={`Contract Number: ${pill.contract_number}`} sx={{ fontSize: 'small' }} />
                                <Chip label={`Phone Number: ${pill.phone_number}`} sx={{ fontSize: 'small' }} />
                                <Chip label={`Corporate: ${pill.is_corporate === 1 ? 'Yes' : 'No'}`} sx={{ fontSize: 'small' }} />
                                <Chip label={`Company Name: ${pill.company_name}`} sx={{ fontSize: 'small' }} />
                            </Stack>

                        </Box>
                        <Box sx={{width: 50}}></Box>
                        <Box>
                            <Box sx={{height: "10%"}}></Box>
                            <Tooltip title={'Delete Ticket'}>
                                <IconButton onClick={handleDelete} sx={{p: 0}}>
                                    <Delete sx={{fontSize: 34}} color='action'/>
                                </IconButton>
                            </Tooltip>
                            <Box sx={{height: "30%"}}></Box>
                            <Tooltip title={pill.done ? 'Reopen Ticket' : 'Close Ticket'}>
                                <IconButton onClick={handleToggleDone} sx={{p: 0}}>
                                    {!pill.done ? <CheckCircleIcon sx={{fontSize: 34}} color='success'/> :
                                        <CancelIcon sx={{fontSize: 34}} color="action"/>}
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>
            )}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{width: '100%'}}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
};

export default MailPill;